/**
 * The add-on features the platform turned on for a site (`site.features` in the workspace). The browser only uses this to
 * decide what to show; the server refuses blog requests on a site without the feature whatever the client does.
 */
export type SiteFeature = "blog" | "shop";

export function siteHasFeature(site: { features: readonly string[] }, feature: SiteFeature): boolean {
  return site.features.includes(feature);
}
